import agent_1Img from '../assets/images/1572621278.webp';
import agent_2Img from '../assets/images/1572621398.webp';
import agent_7Img from '../assets/images/1572621802.webp';
import agent_4Img from '../assets/images/1615409019.webp';
import agent_6Img from '../assets/images/1615575044.webp';
import agent_9Img from '../assets/images/1615575521.webp';
import agent_5Img from '../assets/images/1629474252.webp';
import agent_3Img from '../assets/images/1672758583.webp';
import agent_8Img from '../assets/images/1729868286_1158023.webp';
import agent_10Img from '../assets/images/brokers/Loren Ackerman.webp'
import agent_11Img from '../assets/images/brokers/Chip & Virginia Aikenhead.webp'
import agent_12Img from '../assets/images/brokers/Aryeh Altman.webp'
import agent_13Img from '../assets/images/brokers/brokerNoImg.png'
import agent_14Img from '../assets/images/brokers/Allison Andrus.webp'
import agent_15Img from '../assets/images/brokers/Aleksandar Antonijevic.webp'
import agent_16Img from '../assets/images/brokers/Sonia Bal.webp'
import agent_17Img from '../assets/images/brokers/Rick Balmer.webp'
import agent_18Img from '../assets/images/brokers/Shirley Bell.webp'
import agent_19Img from '../assets/images/brokers/Kathy Besse.webp'
import agent_20Img from '../assets/images/brokers/Sylvia Bethlenfalvy.webp'
import agent_21Img from '../assets/images/brokers/Isabel Beveridge.webp'
import agent_22Img from '../assets/images/brokers/Robert Bince.webp'
import agent_23Img from '../assets/images/brokers/Daryl Black.webp'
import agent_24Img from '../assets/images/brokers/David Black-Charlebois.webp'
import agent_25Img from '../assets/images/brokers/Patricia_Brown.webp'
import agent_26Img from '../assets/images/brokers/Joanna Bunn.webp'
import agent_27Img from '../assets/images/brokers/David Butler.webp'
import agent_28Img from '../assets/images/brokers/John C.  Carr.webp'
import agent_29Img from '../assets/images/brokers/Susan Carter.webp'
import agent_30Img from '../assets/images/brokers/Michela_Cesari.webp'
import agent_31Img from '../assets/images/brokers/Ginette_Charette.webp'
import agent_32Img from '../assets/images/brokers/George Chisholm.webp'
import agent_33Img from '../assets/images/brokers/Alison Clark.webp'
import agent_34Img from '../assets/images/brokers/Wanda Cowie.webp'
import agent_35Img from '../assets/images/brokers/Geeske Cruickshank.webp'
import agent_36Img from '../assets/images/brokers/Richard_Cunningham.webp'
import agent_37Img from '../assets/images/brokers/Cindy Daly.webp'
import agent_38Img from '../assets/images/brokers/Jason Dodd.webp'
import agent_39Img from '../assets/images/brokers/Louise Dodd.webp'
import agent_40Img from '../assets/images/brokers/Jason & Louise Dodd.webp'
import agent_41Img from '../assets/images/brokers/Kelly  Driscoll.webp'
import agent_42Img from '../assets/images/brokers/David Dunkelman.webp'
import agent_43Img from '../assets/images/brokers/Johannah Eansor.webp'
import agent_44Img from '../assets/images/brokers/Diane Elvidge.webp'
import agent_45Img from '../assets/images/brokers/Sarah Anne_Fasullo.webp'
import agent_46Img from '../assets/images/brokers/Michael_Fenn.webp'
import agent_47Img from '../assets/images/brokers/Renate Ferrier.webp'
import agent_48Img from '../assets/images/brokers/Dave Forbes.webp'
import agent_49Img from '../assets/images/brokers/Heather Fuller.webp'
import agent_50Img from '../assets/images/brokers/Kelly Lee Fulton.webp'
import agent_51Img from '../assets/images/brokers/Liz Gibson.webp'
import agent_52Img from '../assets/images/brokers/Maureen Gold.webp'
import agent_53Img from '../assets/images/brokers/Cynthia Lynn Goodchild.webp'
import agent_54Img from '../assets/images/brokers/Chris Graham.webp'
import agent_55Img from '../assets/images/brokers/Lisa Graham.webp'
import agent_56Img from '../assets/images/brokers/Whitney  Grove.webp'
import agent_57Img from '../assets/images/brokers/Yifeng (Celine)_Guo.webp'
import agent_58Img from '../assets/images/brokers/Morgan_Hall.webp'
import agent_59Img from '../assets/images/brokers/Andrew_Hall.webp'
import agent_60Img from '../assets/images/brokers/Carole Hall.webp'
import agent_61Img from '../assets/images/brokers/Doug Heighington.webp'
import agent_62Img from '../assets/images/brokers/Daniela_Hemans.webp'
import agent_63Img from '../assets/images/brokers/Roy_Henzie.webp'
import agent_64Img from '../assets/images/brokers/Lenore Hodgson.webp'
import agent_65Img from '../assets/images/brokers/Brayden Irwin.webp'
import agent_66Img from '../assets/images/brokers/Keegan Irwin.webp'
import agent_67Img from '../assets/images/brokers/Grant Irwin.webp'
import agent_68Img from '../assets/images/brokers/Bruce Jamieson.webp'
import agent_69Img from '../assets/images/brokers/Elizabeth Janak.webp'
import agent_70Img from '../assets/images/brokers/Bradley_Johnston.webp'
import agent_71Img from '../assets/images/brokers/Sabrina_Kashyap.webp'
import agent_72Img from '../assets/images/brokers/Heather Keough.webp'
import agent_73Img from '../assets/images/brokers/Helene_Kerr.webp'
import agent_74Img from '../assets/images/brokers/Rohan Khanna.webp'
import agent_75Img from '../assets/images/brokers/Boris Kholodov.webp'
import agent_76Img from '../assets/images/brokers/Alina Kholodov.webp'
import agent_77Img from '../assets/images/brokers/Colin Kinnear.webp'
import agent_78Img from '../assets/images/brokers/Michael Klasner.webp'
import agent_79Img from '../assets/images/brokers/George Klump.webp'
import agent_80Img from '../assets/images/brokers/Karen Kubis.webp'
import agent_81Img from '../assets/images/brokers/Mercedes Kurowski.webp'
import agent_82Img from '../assets/images/brokers/Heather J. Lake.webp'
import agent_83Img from '../assets/images/brokers/Colin Lavery.webp'
import agent_84Img from '../assets/images/brokers/Maryann Lee.webp'
import agent_85Img from '../assets/images/brokers/Anne Levenston.webp'
import agent_86Img from '../assets/images/brokers/Valerie Logaridis.webp'
import agent_87Img from '../assets/images/brokers/Laura Logaridis.webp'
import agent_88Img from '../assets/images/brokers/Laura & Valerie Logaridis.webp'
import agent_89Img from '../assets/images/brokers/Carol Lome (Irwin).webp'
import agent_90Img from '../assets/images/brokers/Kaitlin Lowy.webp'
import agent_91Img from '../assets/images/brokers/Daniel Lynch.webp'
import agent_92Img from '../assets/images/brokers/Angela Mandalas.webp'
import agent_93Img from '../assets/images/brokers/Judy Manning.webp'
import agent_94Img from '../assets/images/brokers/Janine Mason.webp'
import agent_95Img from '../assets/images/brokers/Jo Matovich.webp'
import agent_96Img from '../assets/images/brokers/Anne McCance.webp'
import agent_97Img from '../assets/images/brokers/Kevin McCarthy.webp'
import agent_98Img from '../assets/images/brokers/Jordan_McKenzie.webp'
import agent_99Img from '../assets/images/brokers/Leslie Mckenzie.webp'
import agent_100Img from '../assets/images/brokers/Emily McLean.webp'
import agent_101Img from '../assets/images/brokers/Edith (Edie)_Michel.webp'
import agent_102Img from '../assets/images/brokers/Peter Mickus.webp'
import agent_103Img from '../assets/images/brokers/Carol Mintz.webp'
import agent_104Img from '../assets/images/brokers/David Naghdi.webp'
import agent_105Img from '../assets/images/brokers/Roger Nahas.webp'
import agent_106Img from '../assets/images/brokers/Victor Ness.webp'
import agent_107Img from '../assets/images/brokers/Joanne_Nevison.webp'
import agent_108Img from '../assets/images/brokers/Sam Obeid.webp'
import agent_109Img from '../assets/images/brokers/Laura Catherine_Oldman.webp'
import agent_110Img from '../assets/images/brokers/Michael_Owen.webp'
import agent_111Img from '../assets/images/brokers/Arthur Parks.webp'
import agent_112Img from '../assets/images/brokers/Mary C._Parks.webp'
import agent_113Img from '../assets/images/brokers/Phillippa Perkins.webp'
import agent_114Img from '../assets/images/brokers/Peter Ricketts.webp'
import agent_115Img from '../assets/images/brokers/Lina Risi.webp'
import agent_116Img from '../assets/images/brokers/Ingrid Ruytenbeek.webp'
import agent_117Img from '../assets/images/brokers/Terri Sapera.webp'
import agent_118Img from '../assets/images/brokers/Farhang Sattar.webp'
import agent_119Img from '../assets/images/brokers/Jonathan Schwarz.webp'
import agent_120Img from '../assets/images/brokers/Eleonora Segal.webp'
import agent_121Img from '../assets/images/brokers/Susie Sheffman.webp'
import agent_122Img from '../assets/images/brokers/Ashlee Shutt.webp'
import agent_123Img from '../assets/images/brokers/Rosalin Smith-Carr.webp'
import agent_124Img from '../assets/images/brokers/Selena Soscia.webp'
import agent_125Img from '../assets/images/brokers/Mark Spraggett.webp'
import agent_126Img from '../assets/images/brokers/Randy Stevenson.webp'
import agent_127Img from '../assets/images/brokers/Alison Strike.webp'
import agent_128Img from '../assets/images/brokers/Shery & Christina_Sutherland.webp'
import agent_129Img from '../assets/images/brokers/Sherry Sutherland.webp'
import agent_130Img from '../assets/images/brokers/Christina Sutherland.webp'
import agent_131Img from '../assets/images/brokers/Sarah Syrja.webp'
import agent_132Img from '../assets/images/brokers/Robin Tully.webp'
import agent_133Img from '../assets/images/brokers/Erik_Vail.webp'
import agent_134Img from '../assets/images/brokers/Kim_Valberg.webp'
import agent_135Img from '../assets/images/brokers/Geon Van Der Wyst.webp'
import agent_136Img from '../assets/images/brokers/Trish Vieira.webp'
import agent_137Img from '../assets/images/brokers/Leslie Wallender-Lyons.webp'
import agent_138Img from '../assets/images/brokers/Sherri Watchorn.webp'
import agent_139Img from '../assets/images/brokers/Sis Weld.webp'
import agent_140Img from '../assets/images/brokers/Leeanne Weld.webp'
import agent_141Img from '../assets/images/brokers/Caroline Wight.webp'
import agent_142Img from '../assets/images/brokers/Gayle Woods.webp'
import agent_143Img from '../assets/images/brokers/Julia Zipresz.webp'
import agent_144Img from '../assets/images/brokers/Farahnaz Zolfaghari.webp'





















export const fetchedAgents = [
  {
    id: 10,
    name: 'Loren Ackerman',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Leslie@example.com',
    phone: '416.300.4711',
    image: agent_10Img,
    language: 'French',
    position: 'Expert',
    designation: 'MCNE - Master Certified Negotiation',
    profileLink: '/profile/jane-smith',
    office: 'J&D Kawarthas'
  },
  {
    id: 11,
    name: 'Chip & Virginia Aikenhead',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Leslie@example.com',
    phone: '416.312.2996',
    image: agent_11Img,
    language: 'French',
    position: 'Expert',
    designation: 'MCNE - Master Certified Negotiation',
    profileLink: '/profile/jane-smith',
    office: 'J&D Kawarthas',
    about: [
      "Chip Aikenhead began his real estate career in 1988. After four years in the commercial division of Royal LePage, he joined the residential side of the business. Chip's experience as an agent on both the commercial and residential side gives him a unique understanding of a real estate transaction. He also brought with him a highly regarded reputation. His unique marketing ability along with his finely tuned negotiating skills, are hallmarks of his decisive professional attitude. With his broad network of relationships in the real estate market, Chip has made long-lasting connections that help him stay in sync with current needs and trends. His uncanny ability to understand what a client is looking for in a home is evidenced by his many return customers and referral clientele. Chip prides himself on his ethics and customer service. His reputation for integrity, dependability and hard work have resulted in annual sales awards. He cares about his clients, many who continue to be friends long after the transaction is complete. Virginia Aikenhead's unflappable style is ideally suited to the emotionally charged experience of selling and purchasing homes. Virginia, a native Torontonian, is a resident of the central area in which she works. She has come to embrace the area with significant depth and appreciation. This allows her to share the valuable perspective only possible through years of living in the same community, in which she has fine-tuned the art of helping people buy and sell their homes and properties. Virginia started her real estate career in 1983 with Royal LePage and has consistently been a top-producer and has been recognized with many sales awards and designations acknowledging her achievements. This success is attributed to a combination of her vast knowledge of the market and her dynamic negotiation, marketing and people skills. Her years of experience have reinforced her own approach to business, namely, to treat others with honesty, respect, discretion and the highest degree of confidentiality. Virginia's clients know immediately that they are in the hands of a seasoned professional who will lead them through their real estate experience to a rewarding conclusion. Virginia is well known in real estate circles as a Top Producer who delivers for her clients."
    ]

  },
  {
    id: 12,
    name: 'Aryeh Altman',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'aryeh@altmanhomes.ca',
    // phone: '416.489.2121',
    image: agent_12Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto'
  },
  {
    id: 13,
    name: 'Morgan Andersen',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Laura@example.com',
    phone: '416.818.0195',
    image: agent_13Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto'
  },
  {
    id: 1,
    name: 'Heather J. Lake',
    role: 'Sales Representative',
    location: 'Toronto, ON',
    email: 'Heather.com',
    phone: '416.587.5363',
    image: agent_1Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto'
  },
  {
    id: 2,
    name: 'Colin Lavery',
    role: 'Sales Representative',
    location: 'Vancouver, BC',
    email: 'Lavery@example.com',
    phone: '416.427.8424',
    image: agent_2Img,
    language: 'French',
    position: 'Expert',
    designation: 'CRA - Canadian Residential Appraiser',
    profileLink: '/profile/jane-smith',
    office: 'J&D Oakville'

  },
  
  {
    id: 3,
    name: 'Carter Levey',
    role: 'Sales Representative',
    location: 'Toronto, ON',
    email: 'Carter@example.com',
    phone: '416.606.6997',
    image: agent_3Img,
    language: 'English',
    position: 'Agent',
    designation: 'SRS - Seller Representative Specialistct',
    profileLink: '/profile/john-doe',
    office: 'J&D Muskoka'
  },
  {
    id: 4,
    name: 'Anne Levenston',
    role: 'Sales Representative',
    location: 'Vancouver, BC',
    email: 'Anne@example.com',
    phone: '416.489.2121',
    image: agent_4Img,
    language: 'French',
    position: 'Expert',
    designation: 'MCNE - Master Certified Negotiation',
    profileLink: '/profile/jane-smith',
    office: 'J&D Kawarthas'

  },
  {
    id: 5,
    name: 'Laura Logaridis',
    role: 'Sales Representative',
    location: 'Toronto, ON',
    email: 'Laura@example.com',
    phone: '416.489.2121',
    image: agent_5Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto'
  },
  {
    id: 6,
    name: 'Carol Lome',
    role: 'Broker',
    location: 'Vancouver, BC',
    email: 'Carol@example.com',
    phone: '098-765-4321',
    image: agent_6Img,
    language: 'French',
    position: 'Expert',
    designation: 'CRA - Canadian Residential Appraiser',
    profileLink: '/profile/jane-smith',
    office: 'J&D Oakville'

  },
  {
    id: 7,
    name: 'Daniel Lynch',
    role: 'Sales Representative',
    location: 'Toronto, ON',
    email: 'john@example.com',
    phone: '123-456-7890',
    image: agent_7Img,
    language: 'English',
    position: 'Agent',
    designation: 'SRS - Seller Representative Specialistct',
    profileLink: '/profile/john-doe',
    office: 'J&D Muskoka'
  },
  {
    id: 8,
    name: 'Kaitlin Lowy',
    role: 'Sales Representative',
    location: 'Vancouver, BC',
    email: 'Kaitlin@example.com',
    phone: '098-765-4321',
    image: agent_8Img,
    language: 'French',
    position: 'Expert',
    designation: 'MCNE - Master Certified Negotiation',
    profileLink: '/profile/jane-smith',
    office: 'J&D Kawarthas'
  },
  {
    id: 9,
    name: 'Leslie Wallender Lyons',
    role: 'Sales Representative',
    location: 'Vancouver, BC',
    email: 'Leslie@example.com',
    phone: '098.765.4321',
    image: agent_9Img,
    language: 'French',
    position: 'Expert',
    designation: 'MCNE - Master Certified Negotiation',
    profileLink: '/profile/jane-smith',
    office: 'J&D Kawarthas'
  },
 
  
  
  
  {
    id: 14,
    name: 'Allison Andrus',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Laura@example.com',
    phone: '416.489.2121',
    image: agent_14Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "Allison grew up in North Toronto and has focused her real estate career on many unique neighbourhoods and distinctive homes.  Her passion for real estate began as a young child when her family built a custom, classically designed home in Lawrence Park – this experience led to a deep appreciation and affinity for the finer details that went into architectural design, high-quality construction and the overall sense of house and home that it offered.",
      "Allison is an award-winning realtor who has built a successful business founded on hard work, professionalism, and a passion for real estate.  Her personable approach and unwavering commitment to honesty and integrity has earned her an excellent reputation among clients and colleagues.  Allison is driven to exceed her clients’ expectations and excels at skillfully helping buyers and sellers navigate the real estate market to ensure an enjoyable and successful experience, even in the most difficult situations.  When you hire Allison as your realtor, she is with you every step of the way from the initial contact to beyond the transaction.",
      "Whether working with buyers or sellers, her objective remains the same: to help clients achieve an exceptional real estate experience.  Most important to her is earning her client’s trust, providing unparalleled service and a real estate experience that she and her clients will be proud of.  Allison knows that she has delivered on this objective when her clients often refer their family and friends to her, which she would attest to be one of the most rewarding aspects of being a realtor.",
      "Giving back to her community and volunteering her time to help those less fortunate is what motivates her in building a successful real estate career."
    ]
  },
  {
    id: 15,
    name: 'Aleksandar Antonijevic',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Laura@example.com',
    phone: '416.489.2121',
    image: agent_15Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 16,
    name: 'Sonia Bal',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sbal@johnstonanddaniel.com',
    // phone: '416.489.2121',
    image: agent_16Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "With nearly three decades of being a proud Torontonian under her belt, Sonia brings a wealth of local and global business acumen to the table. She eagerly anticipates the opportunity to collaborate with you in realizing your real estate objectives by sharing her extensive experiences and insights.",
      "Sonia's professional journey includes significant stints in Dubai and India, where she successfully established and managed her own retail brands. Following this, she made the transition to Toronto alongside her husband and two children. Her fervent interest in real estate investment further enriches her expertise, making her an invaluable asset whether you're aiming to construct your real estate portfolio, navigate home buying or selling, or embark on a relocation journey in this dynamic and rapidly evolving city."
    ]
  },
  {
    id: 17,
    name: 'Rick Balmer',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'rbalmer@johnstonanddaniel.com',
    phone: '416.898.4987',
    image: agent_17Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 18,
    name: 'Shirley Bell',
    role: 'Realtor®',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'shirley@shirleybell.com',
    phone: '416.565.7771',
    image: agent_18Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "Shirley & Whitney, Delivering Real Advice in a Changing Market.",
      "Shirley and Whitney are partners at Johnston & Daniel, A Division of Royal Lepage Real Estate Services, Ltd., Brokerage. We are professionals with established reputations and a proven service record of buying and selling real estate.",
      `We bring our clients an "on-the-street" knowledge of the fastest-growing and up-and-coming neighbourhoods in Toronto and Oakville. Our practice is built upon ensuring the integrity of our transactions for all concerned and providing our clients with true real estate intelligence. We bring careful planning, insightful strategy and professional marketing techniques to help you with the biggest financial investment most people make.`,
      "We believe that the happiest client is an informed client. Helping you is what we do; please let us know how we can support you today!",
      "About Shirley:",
      "With over 25 years in the real estate industry, Shirley is passionate about her career as a REALTOR® and accredits her success to listening carefully to her client's goals and responding to their needs quickly. Being a successful REALTOR® is more than just knowing the housing market, she strongly believes that excellent real estate transactions are the result of careful planning, insightful strategy and professional marketing techniques. Shirley is a consistent award winner having achieved the prestigious Gairdner Award and Diamond Award multiple times with Johnston & Daniel. She is a proud supporter of The Royal LePage Shelter Foundation where she donates a portion of her commission from every sale.",
      "Shirley and her husband are long time residents of Davisville Village where they raised their five children. She is extremely knowledgeable in both home and condominium sales and her clients refer her time and time again. "
    ]
  },
  {
    id: 19,
    name: 'Kathy Besse',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'kathy@kathybesse.ca',
    phone: '416.464.4350',
    image: agent_19Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "Born in Montreal, Kathy has been living in North Toronto for over 30 years and in that time has parlayed her experience in sales promotion, interior decorating and design into her most recent passion – Toronto real estate. She has used her well-honed talent for really listening to her clients and their needs, a deep understanding of Toronto’s neighbourhoods and her keen sense of style to benefit many happy clients over the years. She knows what needs to be done and will work tirelessly to ensure that her clients are satisfied. In 2015, Kathy teamed up with her old friend, Susan Carter, a proven performer at J&D who has been in the business for almost 20 years. Her kind, forthcoming demeanor and keen knowledge of the real estate environment in Toronto is what attracts people to her. Together, they are a positive, supportive team devoted to making the real estate process as seamless and as stress free as possible for their clients whether they are buying or selling. With a profound appreciation of the sensitivities and magnitude of this important transaction, they are the team that you want on your side as you navigate the real estate market."
    ]

  },
  {
    id: 20,
    name: 'Sylvia Bethlenfalvy',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sylviabethlenfalvy@gmail.com',
    phone: '416.617.7590',
    image: agent_20Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 21,
    name: 'Isabel Beveridge',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ibeveridge@sympatico.ca',
    phone: '416.996.8414',
    image: agent_21Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 22,
    name: 'Robert Bince',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'robertbince@johnstonanddaniel.com',
    // phone: '416.898.4987',
    image: agent_22Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 23,
    name: 'Daryl Black',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'darylblack@rogers.com',
    phone: '416.720.6080',
    image: agent_23Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 24,
    name: 'David Black-Charlebois',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'davidcharlebois@johnstonanddaniel.com',
    phone: '647.303.2333',
    image: agent_24Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    ln: 'https://ca.linkedin.com/in/david-a-black-charlebois-b100aa6a',
    about: [
      "David Black-Charlebois is a passionate and personable agent who enjoys working with people from all walks of life. His extroverted personality helps him build rapport and trust with his clients and colleagues. He values the relationships he forms with his peers, friends, and family, and strives to make every interaction positive and memorable. He is dedicated to delivering excellent results and ensuring that everyone involved in the real estate process has a satisfying and enjoyable experience.",
      "He will be delighted to have the opportunity to work with you. He is committed to meeting your expectations and satisfying your needs. You are a valued part of his business and he appreciates your trust in him. Whether it's your first purchase or your tenth, he will be there for you every step of the way. His goal to build a long-lasting relationship with you based on trust and satisfaction.",
      "He is so excited to join you and the forthcoming opportunity! He looks forward to something like this and can't wait to get started. This is exactly what we need to take our business to the next level. So where do we sign?"
    ]

  },
  {
    id: 25,
    name: 'Patricia	Brown',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'patriciabrownto@gmail.com',
    phone: '416.949.9568',
    image: agent_25Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 26,
    name: 'Joanna Bunn',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jkbunn@johnstonanddaniel.com',
    phone: '416.433.3414',
    image: agent_26Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 27,
    name: 'David Butler',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'david@leslievillerealestate.com',
    phone: '416.489.2121',
    image: agent_27Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "Long time Leslieville, Toronto resident who loves to explore the city on his bicycle. Having explored the city over the years I have several favorite parts of town. Depending on your needs for work/school and your choices of transit I can help find you the right choice for your housing in Toronto."
    ]

  },
  {
    id: 28,
    name: 'John C. Carr',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jccarr@sympatico.ca',
    phone: '416.846.3193',
    image: agent_28Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 29,
    name: 'Susan Carter',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'rbalmer@johnstonanddaniel.com',
    phone: '416.543.8320',
    image: agent_29Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    ln: 'https://ca.linkedin.com/in/susan-carter-01aa843',
    about: [
      "Susan’s thoughtful, forthcoming demeanour and keen knowledge of the real estate environment in Toronto are what attract people to her. From her Bay Street beginnings on the floor of the Toronto Stock Exchange, retail sales at McLeod Young Weir, and running the marketing department in a mutual fund startup, Susan developed a strong set of business skills in the financial industry. She continues to monitor both the macro and micro financial and economic issues affecting the real estate market. This skill set combined with her excellent people skills provided a perfect transition to a career in real estate. With over 16 years of experience as a REALTOR® and as a consistent top Award Winner, Susan thrives in an environment that presents new challenges and learning opportunities along the way. A self-professed information junkie, she has obtained numerous designations and accreditations and is continually looking for opportunities to expand her knowledge in everything related to real estate. Susan has a keen eye for architecture and design and never misses an opportunity to trail a home inspector throughout a prospective property to understand every aspect of the exterior and interior of a structure and its systems. Susan has a deep understanding of both the business and personal aspects of real estate transactions. She can wear many hats effortlessly throughout the process with a calm and professional attitude; from strong negotiating skills, strategic decision making and marketing savvy to a patient and empathetic understanding of the emotional challenges involved in the life transition from one home to the next. Getting the job done with the highest level of personal service and the best possible outcome for her clients before, during and after the transaction is her goal."
    ]

  },
  {
    id: 30,
    name: 'Michela Cesari',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'michela@michelacesari.ca',
    phone: '647.830.2010',
    image: agent_30Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 31,
    name: 'Ginette Charette',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'glcharette@rogers.com',
    phone: '416.805.4430',
    image: agent_31Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 32,
    name: 'George Chisholm',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'info@georgechisholm.com',
    phone: '416.587.9999',
    image: agent_32Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/?eid=ARCOUbTxROhwdHhnwoqUbiwl0wUZCwJp5RseiPdsx9OInAQbMW_5dm2sZDSRjs7AAGoF3nXleTZo2hpg',
    x: 'https://twitter.com/ChisholmTeam',
    in: 'https://www.instagram.com/chisholmteam',
    about: [
      'George has been a Real Estate Sales Representative since 1983, serving both residential and commercial clients. A Toronto native, George’s in-depth knowledge of the city, and it’s most prestigious neighbourhoods is truly unmatched. With a steadfast motto to always put his clients first, he has a reputation for outstanding and genuine customer service. Through his unique experience in building homes across the globe for nearly 4 decades, George has an extensive construction background which is a valuable asset for anyone looking to build, renovate, invest or simply move in to a high-quality home. George lives in Toronto with his wife Sonia and their dog Archie. Their lives are enriched by their two daughters, Barbara (and her husband Marco) and Lauren (and her partner Shaun). George donates to many charitable organizations year over year, but close to his heart are the Enbridge Ride to Conquer Cancer, Sick Kids and Princess Margaret Hospital. George has won multiple awards over the years including “Top 50 Agents by value of listings sold.”'
    ]

  },
  {
    id: 33,
    name: 'Alison Clark',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'alisonzclark@gmail.com',
    phone: '647.274.6971',
    image: agent_33Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/AlisonClarkRE/",
    in: "https://www.instagram.com/alisonclark_realestate/",
    ln: "https://www.linkedin.com/in/alison-clark-realestate",
    about: [
      'My clients look forward to enjoying a personal touch as I keep in close contact so they understand that they are my number one priority.',
      "Testimonial When moving to Toronto, Alison Clark was recommended to us to assist in a condo rental. She was a very accommodating realtor who listened to our needs and gave a great deal of time and effort to procure the best unit for us.  She was extremely reliable and professional, and we can't thank her enough for her assistance! -Pam K.",
      "North Toronto has been my home for 20 years.  I know it well having a son who attended the wonderful John Wanless Jr. Elementary School.  Being a member of the Toronto Cricket Skating and Curling Club (Cricket Club), and now living a short distance from our wonderful family friendly club, allows me to assist anyone interested in this special area of Toronto.",
      "Testimonial I was so fortunate to get to work with Alison during one of my first experiences moving to a new city and renting on my own.  She wqas extremely patient with me and worked very quickly to help me find something perfect in the very short tinme period I had to move!  I will absolutely continue to use Alison for my future moves! - AK",
      "My clients enjoy my competitive spirit and level-headedness in stressful situations; skills I gained as a National Level figure skater in ice dancing.  I continue figure skating and competing today at competions around the world.",
      "When not skating or assisting clients I volunteer with the Canadian Cancer society and I am a volunteer ambassador at the Toronto Cricket Skating and Curling Club."
    ]

  },
  {
    id: 34,
    name: 'Wanda Cowie',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'wandacowie@gmail.com',
    phone: '416.402.9322',
    image: agent_34Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/wandacowieluxuryrealestate/",
    in: "https://www.instagram.com/wandacowieluxuryrealestate/?hl=en",
    ln: "https://www.linkedin.com/in/wanda-cowie-8841315b/",

  },
  {
    id: 35,
    name: 'Geeske Cruickshank',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'gcruickshank@sympatico.ca',
    phone: '416.565.9282',
    image: agent_35Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 36,
    name: 'Richard Cunningham',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'richard@housecanada.net',
    // phone: '416.805.4430',
    image: agent_36Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 37,
    name: 'Cindy Daly',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'cindy@cindydaly.ca',
    phone: '416.409.5757',
    image: agent_37Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 38,
    name: 'Jason Dodd',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jdodd@johnstonanddaniel.com',
    phone: '416.347.3633',
    image: agent_38Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/LouiseAndJasonDodd",
    in: "https://www.instagram.com/louiseandjasondodd",
    ln: "https://www.linkedin.com/in/jason-dodd-02365513"

  },
  {
    id: 39,
    name: 'Louise Dodd',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'louise@louisedodd.com',
    phone: '416.809.2076',
    image: agent_39Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/LouiseAndJasonDodd",
    in: "https://www.instagram.com/louiseandjasondodd",
    about: [
      "Serving Toronto's, and the Greater Toronto Area's real estate needs full time since 1982. With Johnston & Daniel, Division of Royal LePage Real Estate Services Ltd. Brokerage from 1996 to the present."
    ]

  },
  {
    id: 40,
    name: 'Jason & Louise Dodd',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jdodd@johnstonanddaniel.com',
    phone: '416.347.3633',
    image: agent_40Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 41,
    name: 'Kelly Driscoll',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'kelly@kdriscoll.ca',
    phone: '416.705.4064',
    image: agent_41Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 42,
    name: 'David Dunkelman',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ddunkelman@bell.net',
    phone: '416.726.6574',
    image: agent_42Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 43,
    name: 'Johannah Eansor',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'johannaheansor@hotmail.com',
    phone: '416.910.0950',
    image: agent_43Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 44,
    name: 'Diane Elvidge',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'dianem.elvidge@gmail.com',
    phone: '416.624.5393',
    image: agent_44Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 45,
    name: 'Sarah Anne Fasullo',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'results@fasullocrigger.com',
    // phone: '416.910.0950',
    image: agent_45Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 46,
    name: 'Michael Fenn',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'michaelandrewfenn@gmail.com',
    phone: '647.230.4349',
    image: agent_46Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 47,
    name: 'Renate Ferrier',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ferrierrenate@gmail.com',
    phone: '416.725.5503',
    image: agent_47Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 48,
    name: 'Dave Forbes',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'david.forbes@bell.net',
    phone: '416.258.1459',
    image: agent_48Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 49,
    name: 'Heather Fuller',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'heather@heatherfuller.com',
    phone: '416.720.3743',
    image: agent_49Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/heather.fuller.942',
    about: [
      'My career in real estate has taught me the value of service - both personal and professional. As a Broker I bring a business-like approach to my profession. I know the importance of listening carefully and planning an effective strategy to meet the needs of my clients.'
    ]

  },
  {
    id: 50,
    name: 'Kelly Lee Fulton',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'kelly@kellyfulton.ca',
    phone: '416.520.9655',
    image: agent_50Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 51,
    name: 'Liz Gibson',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lgibson@johnstonanddaniel.com',
    phone: '416.489.2121',
    image: agent_51Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 52,
    name: 'Maureen Gold',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'goldmg@rogers.com',
    phone: '647.887.1054',
    image: agent_52Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 53,
    name: 'Cynthia Lynn Goodchild',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'cynthia@cynthiagoodchild.com',
    phone: '416.875.6137',
    image: agent_53Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 54,
    name: 'Chris Graham',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'cgrahamhomes@gmail.com',
    phone: '416.428.3351',
    image: agent_54Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 55,
    name: 'Lisa Graham',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lisa@lisagrahamhomes.com',
    phone: '647.203.1800',
    image: agent_55Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/lisagrahamhome",
    in: "https://www.instagram.com/lisagrahamhomes/",
    about: [
      "It is so nice to meet you!",
      "You could say that real estate is in my blood. Growing up, I watched my mother thrive in this business by always putting the needs of her clients first. After my own eight-year career in marketing, I had the marketing expertise to launch Lisa Graham Homes in 2004. Property stying, expert negotiation, best possible presentation of each property, accurate pricing and assisting you with yours specific needs & circumstances are my passions to this day.",
      "As one of Toronto's top realtors for 20 consecutive years, I have the privilege of making a difference in the lives of buyers, sellers, and investors every day. My secret is simple: I am passionately committed to your success, whether your goal is to move up to your forever home, downsize to upsize your lifestyle, make a first home purchase or realizing the dream of a waterfront cottage or ski chalet.",
      "As an expert in my field I would be delighted to personally guide you through everything you need to know to make the best decisions along the way. I leverage the latest technology to ensure you receive top-notch service and achieve the results you're seeking. My clients often tell me that the process was simpler and more profitable than they could have imagined.",
      "I love helping Toronto buyers and sellers succeed in making their real estate dreams a reality. Confidentiality, loyal service and exceptional results are guaranteed. Please get in touch with me directly to learn more about how I can help."
    ]

  },
  {
    id: 56,
    name: 'Whitney Grove',
    role: 'Realtor®',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'johannaheansor@hotmail.com',
    phone: '416.910.0950',
    image: agent_56Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: "https://www.facebook.com/SmartMovesTO",
    in: "https://www.instagram.com/toronto_whitney_grove",
    yt: "https://youtube.com/@whitneygrove381",
    about: [
      "Shirley & Whitney, Delivering Real Advice in a Changing Market.",
      "Shirley and Whitney are partners at Johnston & Daniel, A Division of Royal Lepage Real Estate Services, Ltd., Brokerage. We are professionals with established reputations and a proven service record of buying and selling real estate.",
      `We bring our clients an "on-the-street" knowledge of the fastest-growing and up-and-coming neighbourhoods in Toronto and Oakville. Our practice is built upon ensuring the integrity of our transactions for all concerned and providing our clients with true real estate intelligence. We bring careful planning, insightful strategy and professional marketing techniques to help you with the biggest financial investment most people make.`,
      "We believe that the happiest client is an informed client. Helping you is what we do; please let us know how we can support you today!",
      "About Whitney:",
      "Whitney has a solid reputation at Johnston & Daniel and first-hand experience in buying, selling and design.  Prior to real estate, Whitney spent 20 successful years in various corporate sales leadership and marketing roles. This experience has allowed Whitney to provide her clients with a unique set of skills with best-in-class marketing strategies, proven negotiating skills and exceptional customer service. Whitney’s integrity, warmth, knowledge and professionalism is what sets her apart in the real estate profession…just ask her clients. ",
      "Born and raised in Oakville, Whitney now lives with her husband and two teenage children in the Yonge & Lawrence neighbourhood.  Real estate has always been Whitney’s passion and sharing that passion with her clients is her dream come true."
    ]

  },
  {
    id: 57,
    name: 'Yifeng (Celine)	Guo',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'yfguo@johnstonanddaniel.com',
    phone: '647.823.8033',
    image: agent_57Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 58,
    name: 'Morgan Hall',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'carolehallpages@gmail.com',
    phone: '416.460.7502',
    image: agent_58Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      'Morgan Hall was raised in Lawrence Park and received a Bachelor of Business Administration and a Bachelor of Science in Financial Mathematics from Wilfrid Laurier University. While in school she also completed Laurier’s co-op program and the first level of her CFA. Morgan’s education is a testament to the work ethic she learned from her mother. Her business smarts and financial background enable Morgan to find creative ways to help launch first time home buyers and get the best price for her clients.',
      "The experience and market knowledge Morgan has gained working with a top agent for the past five years is unparalleled. She has a comprehensive understanding of high-end real estate and Toronto’s unique neighbourhoods. Morgan brings a younger and fresh perspective to the business.",
      "Nobody deserves to have your business automatically – Carole and Morgan are prepared to work for it and always put their client’s needs first. You can be confident in their ability to navigate your family through the Toronto Real Estate Market."
    ]

  },
  {
    id: 59,
    name: 'Andrew Hall',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'andrew@hallrealestate.ca',
    phone: '416.616.9587',
    image: agent_59Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/hallrealestate.ca',
    li: 'https://www.linkedin.com/in/hallrealestate',
    about: [
      "I use the tag line “Recommended for a Reason” for many reasons, the most important being that my business is built 100% on recommendations from clients, family, friends, and associates. My clients tell me there are numerous reasons they recommend me. They know that my number one priority is integrity and professionalism. They know that I say what I will do and do what I say. They know me as a straight shooter who tells it like it is. They have seen that my business has been built on the foundation of hard work, attention to detail, commitment and providing sound practical advice. It is my clients that have made me successful and I never forget that for a moment. From students looking for their first rental apartment to busy executives searching for their “forever home”, I treat everyone with respect and a level of customer service that is unmatched."
    ]

  },
  {
    id: 60,
    name: 'Carole Hall',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'results@carolehall.com',
    phone: '416.460.4148',
    image: agent_60Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      'Carole Hall is a seasoned Toronto Realtor and consistent top producer with over 40 years of award winning service in residential real estate. Having raised her two children in Lawrence Park, she understands that buying and selling real estate is one of the most important decisions a family will make in their lifetime. Her ability to look at the big picture while navigating the fine details of real estate is invaluable to her clients. She is always trying to get the best results for her clients keeping in mind resale value.',
      'Whether buying or selling, in a strong or challenging market, regardless of the situation Carole works hard to understand your unique needs and provide sound real estate advice. She has the experience and professionalism to tackle the most complicated real estate transactions. Carole has an enviable reputation and a loyal following of happy clients and friends.',
      'As one of her clients once said:',
      '“I really like your style - professional, personable, no nonsense, fast moving, and clever in negotiating.”',
      'Nobody deserves to have your business automatically – Carole and Morgan are prepared to work for it and always put their client’s needs first. You can be confident in their ability to navigate your family through the Toronto Real Estate Market.'
    ]

  },
  {
    id: 61,
    name: 'Doug Heighington',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'doug@homeinstinct.com',
    phone: '416.455.4575',
    image: agent_61Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      'Doug Heighington understands that real estate decisions require thoughtful, impartial and experienced counsel. As a former investment executive. Doug knows that home ownership can be one of the most significant investments you make. A native of central Toronto, he couples his strong understanding of markets and neighbourhood trends with candour, insight and support for the purchase and sale of properties in Toronto. Through the management of multiple renovations, Doug has developed a keen instinct for recognizing both the potential and the limitations of real estate investments and applies this wisdom to support intelligent decision making.. This approach includes applying smart pricing and negotiation strategies with a diligent approach to capturing and assessing maximum value.',
    ]

  },
  {
    id: 62,
    name: 'Daniela Hemans',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'dhemans@johnstonanddaniel.com',
    phone: '416.489.2121',
    image: agent_62Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/Daniela-Hemans-Real-Estate-1723755214542019',
    in: 'https://www.instagram.com/hemans_real_estate/',
    about: [
      `With over 14 years experience and knowledge in the Toronto Real Estate Market, I am committed to delivering outstanding personalized service. I understand that being available and immediately responsive to my clients' needs is paramount. Whether a first time home buyer or a seasoned investor, I will go the extra mile to ensure your experience is both positive and memorable. My enthusiasm, professionalism and passion for clients, sets me apart from the rest. TORONTO - Let's make it your city !`
    ]

  },
  {
    id: 63,
    name: 'Roy Henzie',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'henziefishing@gmail.com',
    phone: '416.358.7086',
    image: agent_63Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',


  },
  {
    id: 64,
    name: 'Lenore Hodgson',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lenorehodgson@rogers.com',
    phone: '416.876.6528',
    image: agent_64Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto'

  },
  {
    id: 65,
    name: 'Brayden Irwin',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'brayden@lomeirwin.com',
    phone: '416.617.4606',
    image: agent_65Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      'A Toronto native and former Toronto Maple Leaf, Brayden has successfully channeled the dedication and discipline honed through years of professional athletics into a burgeoning real estate career. Brayden has injected his own energetic approach into a longstanding family business, keeping his competitors on their toes and ensuring that his clients are always one step ahead. Himself an investor with an ever-expanding portfolio of properties - from pre-construction condominiums, to semi-detached family homes, to multi-unit apartment buildings - Brayden is consistently determined to help his clients make smart financial decisions that will benefit themselves and their families for generations to come. In fact, Brayden’s specialty has proven to be turning first-time home buyers into savvy investors. “My philosophy is to tell people what they need to hear as opposed to what they want to hear, so that they can make informed decisions based on fact not opinion.” “As first-time home buyers we were anxious for the process ahead but working with Brayden eased all those nerves. From the start he was attentive to our needs and kept communication lines open. We knew which home we wanted but were wary about moving forward because it wasn’t within our budget. I remember Brayden telling us not to give up. His hard work and determination got us the home well under asking!” - Diana & Aaron',
    ]

  },
  {
    id: 66,
    name: 'Keegan Irwin',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'keegan@lomeirwin.com',
    phone: '416.489.2121',
    image: agent_66Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 67,
    name: 'Grant Irwin',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'grant@lomeirwin.com',
    phone: '416.723.4548',
    image: agent_67Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      'Grant’s business-minded approach to real estate stems from his previous 25 years of service to his family’s company, Irwin Toys Ltd. A longtime resident of Toronto and father of four children, Grant has developed a unique perspective and familiarity when it comes to the distinct offerings of Toronto neighbourhoods and is motivated to match families with properties that not only meet their needs but exceed their expectations. Grant’s clients appreciate his patience and steadfast demeanor, always working to alleviate the pressures of such an important financial decision as buying or selling a home. “I treat each client with the same high standard of care that I would take with my own family”. “We were first attracted to the Lome Irwin Team when we met Grant at an open house he was conducting. His professional presentation, diligent and courteous follow up convinced us to invite him to meet with us to discuss the selling of our home and compete with two other firms for our business, which through his thoroughness and preparedness he won!” - Steve & Linda',
    ]

  },
  {
    id: 68,
    name: 'Bruce Jamieson',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'bjamieson@johnstonanddaniel.com',
    phone: '416.809.8250',
    image: agent_68Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',


  },
  {
    id: 69,
    name: 'Elizabeth Janak',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ejanak6010@rogers.com',
    phone: '416.358.7778',
    image: agent_69Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',


  },
  {
    id: 70,
    name: 'Bradley Johnston',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'bradjohnston@johnstonanddaniel.com',
    phone: '647.525.0370',
    image: agent_70Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',


  },
  {
    id: 71,
    name: 'Sabrina Kashyap',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'skashyap@johnstonanddaniel.com',
    // phone: '416.460.4148',
    image: agent_71Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',

  },
  {
    id: 72,
    name: 'Heather Keough',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'heatherjkeough@gmail.com',
    // phone: '416.460.4148',
    image: agent_72Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',


  },
  {
    id: 73,
    name: 'Helene Kerr',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'helene@helenekerr.com',
    phone: '647.839.4104',
    image: agent_73Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/Helene-Kerr-The-Best-in-Toronto-Real-Estate-Services-1158217234319522',
    x: 'https://twitter.com/HeleneAtJandD',
    li: 'https://www.linkedin.com/in/helene-kerr-673a71a',
    about: [
      `Whether you are a veteran, with several home purchases under your belt, or are new to the real estate market, I believe that buying a home is not just a dollar and cents economic investment. It’s that feeling you get when you walk thru the door, that you’ve arrived HOME. This is the result I strive to deliver to all my clients. I came to real estate after a successful career in sales, marketing and project management at IBM Canada, where I held both country-wide and North American responsibilities and won a number of marketing awards. I am also no stranger to home construction, having a spouse in the industry and having renovated many homes over the years. I have worked closely with architects, structural engineers, and trades, and have been through the building permit and Committee of Adjustment processes first hand. I know what physically goes into the making of a house, and what to look for beyond the fresh paint and bowl of apples artfully arranged on the kitchen counter. I love Toronto. I grew up in New York City and came here to do graduate work at the University of Toronto. Like New York, Toronto is truly a city of ever-changing neighbourhoods; each with its own character and appeal. So whether you are looking for a large family home on a street with 100-year-old trees or a loft conversion in an edgy, evolving area, I can help you find that sweet spot. And if you're relocating from the USA to Toronto, why not work with a Realtor who has "been there, done that"? I am proud to be a member of the highly professional team at Johnston & Daniel, where luxury is an experience, not a price tag. I look forward to working with you to achieve the results you want ... whether to find the home that speaks to your heart, or successfully market your current home.`,
    ]

  },
  {
    id: 74,
    name: 'Rohan Khanna',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'results@carolehall.com',
    phone: '416.460.4148',
    image: agent_74Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 75,
    name: 'Boris Kholodov',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'alina@agentboris.com',
    phone: '416.830.1987',
    image: agent_75Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 76,
    name: 'Alina Kholodov',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'boris@agentboris.com',
    phone: '416.920.5888',
    image: agent_76Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 77,
    name: 'Colin Kinnear',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'colin@colinkinnear.com',
    phone: '416.565.3304',
    image: agent_77Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 78,
    name: 'Michael Klasner',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'michaelklasner@gmail.com',
    // phone: '416.920.5888',
    image: agent_78Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 79,
    name: 'George Klump',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'georgeklump@gmail.com',
    phone: '416.525.2952',
    image: agent_79Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 80,
    name: 'Karen Kubis',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'karen@karenkubis.com',
    phone: '416.258.6400',
    image: agent_80Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/Karen-Kubis-Johnston-Daniel-a-Division-of-Royal-LePage-Real-Estate-353248931371250',
    x: 'https://twitter.com/yyzrealtyguru',
    in: 'https://www.instagram.com/kubiskaren',
    li: 'https://www.linkedin.com/in/?originalSubdomain=ca',
    about: [
      "GET TO KNOW ME. I am a full time professional Realtor working in the greater Toronto area. I grew up in the business as my father was a successful Broker in Essex County for nearly 55 years. As well as valuable experience in all aspects of the market, I studied Environmental Studies at the University of Waterloo with a focus on Urban and Regional Planning. I am also a past member of the Appraisal Institute of Canada and worked as a full time Appraiser in Toronto for Banks,Trust Companies, Government Departments and Private Individuals. I have been licensed since 1972, the summer after my first year at University of Waterloo. (Oh No... that long ago!) but actually, grew up in the business answering the home phone line for my Father’s Brokerage, Kubis Realty Ltd. and sitting at Open Houses in his residential developments after school and weekends. In those days the rules were somewhat lax. When I moved from the Windsor area to live and work in Toronto, I worked as a full time Real Estate Appraiser. This gave me the experience and confidence to work anywhere in the GTA. A good thing. My dad has had a profound influence on my career and has greatly inspired me to be successful.",
      "He was a risk taker, forward thinker and a pioneer in this profession of ours. He retired as a very active Realtor, at the age of 82. He still goes on the computer daily to keep in touch! Characteristics That Make Me Successful In My Business: I have a degree in Environmental Studies (BES) where I formally studied Urban Geography and Urban and Regional Planning. I also spent 7 or 8 years working as a full time Real Estate Appraiser when I first moved to Toronto. This has given me the experience and confidence to work all over in the GTA. This is helpful as my clients are mostly repeat or referrals and so I am there to service their needs. I have unlimited PATIENCE. My clients can attest to this and the majority of them have trusted me with repeat and referral business. The Top Three Things That Separate Me From The Competition: 1. I pride myself in the fact , that I offer personal service. I handle the process from beginning to end and this results in a Flawless experience. 2. Knowledge: I have been a life-long student of this profession. I have the formal education and the street smarts. 3. Experience: I have worked in large and small markets (Windsor/Essex, Kitchener Waterloo, Toronto) and have seen and survived every economic up and down that this Industry has gone through in the past decades. I have had success in times of 20+% mortgage interest rates as well as 1.5%. It has been my life! Choose Wisely... Choose Experience!"
    ]
  },
  {
    id: 81,
    name: 'Mercedes Kurowski',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'mercedesk@johnstonanddaniel.com',
    phone: '647.248.7733',
    image: agent_81Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 82,
    name: 'Heather J. Lake',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'hjlake01@gmail.com',
    phone: '416.587.5363',
    image: agent_82Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 83,
    name: 'Colin Lavery',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'colin.lavery@gmail.com',
    phone: '416.427.8424',
    image: agent_83Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 84,
    name: 'Maryann Lee',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'malee@johnstonanddaniel.com',
    // phone: '416.920.5888',
    image: agent_84Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 85,
    name: 'Anne Levenston',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'anne@annelevenston.ca',
    phone: '416.489.2121',
    image: agent_85Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "After 25 years as an editorial photographer, when our children were in their teens, I embarked on a career as a Realtor. My visual training and skills working with the public turned out to be a winning combination for my clients. For the past 18 years I have had a successful business helping people navigate through a fast-paced real estate market in Toronto. My business is referral-based and comes primarily through word of mouth from enthusiastic past clients."
    ]
  },
  {
    id: 86,
    name: 'Valerie Logaridis',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'valerielogaridis@gmail.com',
    phone: '416.618.8350',
    image: agent_86Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 87,
    name: 'Laura Logaridis',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lauralogaridis@gmail.com',
    phone: '416.489.2121',
    image: agent_87Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 88,
    name: 'Laura & Valerie Logaridis',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lauralogaridis@gmail.com',
    phone: '416.489.2121',
    image: agent_88Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 89,
    name: 'Carol Lome (Irwin)',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'carol@lomeirwin.com',
    phone: '416.994.4243',
    image: agent_89Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "A veteran Toronto Realtor and consistent top producer, Carol Lome has spent more than three decades building relationships with buyers and sellers in Toronto’s most sought-after neighbourhoods. Carol’s market knowledge is refined to the point that she can provide nuanced information down to the very street and reference off-market and exclusive sales – details that provide immeasurable value to her clientele. Also of value to her clients is Carol’s extensive knowledge of renovations, including quality of workmanship and materials, and what types of renovations provide the best return on investment. The service that Carol provides to her clients is firmly rooted in knowledge, integrity, and results. The overwhelming amount of repeat business and continued referrals from her past clients is a testament to this. Carol is a Lifetime Chairman’s Member – Johnston & Daniel’s most esteemed award. She has raised four children in Toronto and understands that buying and selling real estate is one of the most important decisions that a family will make in their lifetime. Carol states “I believe in family, security, and community and when I say that, ‘we know it, we live it, we sell it,’ I want my clients to know that not only do I understand this market but that I am also an active member of this community.” Carol’s listings are frequently featured in the Globe and Mail’s Done Deals and Home of the Week, and she was recently selected as an expert speaker on renowned international real estate trainer Richard Robbins’ podcast. “Carol, I want to thank you for selling my house – you achieved amazing results in such a short time. The results of course were based totally on your knowledge and understanding of the housing market. Your motto is truly apt!” - Louise"
    ]
  },
  {
    id: 90,
    name: 'Kaitlin Lowy',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'klowy@johnstonanddaniel.com',
    phone: '416.569.9067',
    image: agent_90Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 91,
    name: 'Daniel Lynch',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'dlynch@sympatico.ca',
    phone: '416.938.2002',
    image: agent_91Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 92,
    name: 'Angela Mandalas',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'am@angelamandalas.com',
    phone: '416.906.2122',
    image: agent_92Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 93,
    name: 'Judy Manning',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'judymanning@rogers.com',
    phone: '416.721.8551',
    image: agent_93Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "My established track record of success for my clients has made me a consistent top producer within all the fields I have worked in over the years. I bring a proven record of experience and honesty to the table for my clients based upon my knowledge of a wide variety of business practice and my experience living in the Greater Toronto Area in a number of different neighbourhoods. Beginning over twenty-five years ago I was a property manager for a family business on Bay Street in the financial industry. My role was both as the office manager/bookkeeper and as the manager of the company’s real estate division. The company acquired over thirty-three rental properties over a ten year period which I managed including the organization of advertising, decorating, managing of rentals, renovation and the sale of the properties and purchase of new properties. After the company was sold I moved into the decorating business until I was hired to work in the United States (Florida) for a home decorating business that I eventually bought myself and transformed into two retail outlets that were eventually sold. My goal is to give my clients a wealth of experience & expertise to aid them to understand and analyze the current market so they can make the correct financial decisions. My success stems from my honest approach, my varied education and my real estate market know-how combined with hard work and commitment to the best interests of my clients. I make no exaggerated or false promises and use no unconventional systems or suggestions – just me working diligently for all my clients using ethical proven methods. In today’s real estate environment in Toronto, it is vital to work with a professional you can trust and rely on. Working with the proven success of J&D and I whether buying or selling your primary residence, another property for use or income, or moving, I am here to help you make smart and informed decisions, protect your interests and make your home ownership dreams come true. Thanking you in advance for the opportunity to represent you!"
    ]
  },
  {
    id: 94,
    name: 'Janine Mason',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'janine@fasullocrigger.com',
    phone: '416.414.9760',
    image: agent_94Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/janinerealty',
    x: 'https://twitter.com/@janinerealty',
    in: 'https://www.instagram.com/janinemasonrealestate',
    li: 'https://www.linkedin.com/in/janinerealty',
    about: [
      "Janine strives to be one of the best real estate agents and is committed to providing her clients with the best possible service. She devotes herself to ensure a successful and enjoyable experience. While being extremely hard working, organized, dedicated, and most of all trustworthy, she develops long-lasting relationships and friendships with her clients who depend on her. As a very proud member of The FasulloCrigger Real Estate Team. The team is admired throughout the industry for its personal and strategic concierge-style approach, and it is an honor to be a part of this group. We are recognised as an award-winning Broker and multiple recipients of Johnston and Daniel’s most prestigious awards for sales achievements. Together with his wealth of knowledge and this unique team approach, we can assist you in all your real estate needs. While continuing to provide the highest level of service, with honesty and integrity, we will also be able to provide deep, trusted insights to provide sound advice and knowledge, that is tailored to each client’s specific needs. We specialize in Residential & Commercial Sales and leases as well as Pre-Construction condominium sales."
    ]

  },
  {
    id: 95,
    name: 'Jo Matovich',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jomatovich@rogers.com',
    phone: '416.579.4126',
    image: agent_95Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 96,
    name: 'Anne McCance',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'amccance@johnstonanddaniel.com',
    phone: '647.966.2663',
    image: agent_96Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 97,
    name: 'Kevin McCarthy',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'homes@kevinmccarthy.ca',
    phone: '416.985.9393',
    image: agent_97Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 98,
    name: 'Jordan	McKenzie',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'turley.jordan@johnstonanddaniel.com',
    phone: '416.990.3175',
    image: agent_98Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 99,
    name: 'Leslie Mckenzie',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'Lesliemckenzie707@gmail.com',
    phone: '416.707.4231',
    image: agent_99Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/lesliemckenzierealestate',
    about: [
      "Binging buyers and sellers together for over 30 years"
    ]
  },
  {
    id: 100,
    name: 'Emily McLean',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'emily.mclean@johnstonanddaniel.com',
    phone: '416.489.2121',
    image: agent_100Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    li: 'https://www.linkedin.com/in/emily-mclean-95b897292',
    about: [
      "With a passion for connecting people with their dream homes, Emily is a dedicated and knowledgeable real estate agent with a client-centric approach to her business. She maintains her finger on the pulse, staying up to date on the latest trends, property values, and market as a whole. ",
      "Emily is tech savvy, possesses attention to detail, and is an effective communicator and negotiator. Specializing in residential sales, she holds a keen understanding of the diverse local markets that make each neighbourhood unique; drawing from her own personal experience of being born and living in Toronto. ",
      "Emily is dedicated to providing exceptional service, guiding clients through every step of the selling and buying process with expertise and integrity, utilizing every tool at her disposal. Her commitment is to make your real estate journey seamless and stress free. "

    ]

  },
  {
    id: 101,
    name: 'Edith (Edie)	Michel',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ediemichel@rogers.com',
    phone: '416.671.6163',
    image: agent_101Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "Edie is an accomplished Toronto realtor and successful agent with Johnston & Daniel, a Division of Royal LePage Real Estate Service Ltd, Brokerage. She has been working as a realtor with Johnston & Daniel since 2013 and was the proud winner of the Award of Excellence in 2018.",
      "As a lifelong Torontonian, Edie has the knowledge her clients need to work  within established  neighbourhoods of the city, and is passionate about discovering new up and coming neighbourhoods. Whether it’s a client downsizing to a smaller home or condo, a first time buyer or a family buying their forever home, Edie believes it’s important to Build Trust First.",
      "Downsizing & Estate Services",
      "As a realtor with experience providing compassionate and professional real estate and home organization services, Edie has earned herself the reputation of being an agent who can successfully transition seniors and boomers to their new chapter.",
      "Edie helps transition boomers and seniors by helping them declutter, downsize, and prepare their homes for sale.  Downsizing from a family home can often be overwhelming. The Michel Group’s trusted  brand was built by  providing concierge level service at every juncture  with  honest, compassionate, and professional real estate and home organization services.",
      "Edie is the  owner of NEATSPACES, a professional organizing, downsizing, estate and decluttering company, where she is able to further leverage her real estate knowledge by preparing homes to sell and managing client moves.  Armed with an experienced team and specific designations to work with seniors looking to downsize their home, and with executors settling an estate, Edie together with Neatspaces has a roster of trusted partners to guide people through times of transition.",
      "First Time Buyers",
      "Edie has renovated several homes back to the studs which has given her a solid foundation in understanding not only the potential of a home but  the mechanics of a home. Buying a home that needs or has the potential for improvement is a great way for a first time buyer to enter the market and  to build equity. Edie is able to help buyers see the potential a home has for renovation or future expansion. ",
      "Her love of design, trained eye and experience help focus the first time buyer on the important things when making their first purchase. ",
      "Pre-Listing Decluttering and Move Management",
      "The Michel Group can manage everything from getting your home ready to sell, through to packing, moving and setting up your new home.",
      "The Pre-Listing process is critical in maximizing the value in your home.  The Neatspaces’ team of trained professional organizers are experts in this process.  We have created a detailed Pre-Listing Guide for homeowners so even the smallest thing is attended to.",
      "Let’s face it, most people do not enjoy the process of moving.  It adds stress to already busy lives, is physically demanding and has a lot of moving parts.  Whether you are a young family, a downsizer moving into a condo or a retirement community, the team at Neatspaces will ensure you have a smooth move, attending to all the details so you can remain focused on other things.",
      "Our Commitment",
      "Equipped with experience in both real estate and financial services, Edie understands that a person’s home is often their biggest investment and largest asset. Edie provides compassionate, emotionally intelligent and educated real estate services to help both new and experienced home owners. Our goal is to Build Trust First so you will have full confidence in the integrity of the process.",
      "We partner with you from the beginning to make the buying or selling process as easy as possible. The Michel Group and the team at Neatspaces will relieve  the overwhelming load of preparing your house to sell.  Experts at decluttering, sorting and organizing, we will help you identify what you want to keep and work with you to dispose of the rest.  We have ideas to  help you create lasting  legacies of things that are special to you but you don’t have the space to take with you.",
      "Call Edie today to learn how she can help you.",
      "Giving Back to the Community",
      "Community has always been important to Edie, whether it’s a neighbourhood, a school or a cause. Edie has volunteered  for over 35 years.  She is grateful for the opportunities that allowed  her to gain experience to become the Chairperson of large fundraisers, being a  Not-for Profit  board member and committee member throughout the years. She is currently the Director of Finance for the Professional Organizers in Canada and Vice-Chair of the Toronto Chapter. Prior to that she worked on the Night of Promise Gala Committee for the Juvenile Diabetes Research Foundation, and chaired the fundraising and governance committees in her role as board member for  Rugby Ontario.",
      "Her passion for homes, project management and voluntarism began through her membership in the Junior League of Toronto where she gained experience and training on various committees, held several board positions and  co-chaired the Graydon Hall Designer Showhouse in 2000 raising over $500,000 for the Junior League and  community. And naturally volunteering at her children’s schools over the years was always a favourite way to give back."
    ],
    //Certificates and  Designations
    certificates: [
      "Rotman Not-for Profit Governance Essential Course",
      "Certified Executor Advisor CEA",
      "Senior Real Estate Specialist SRES",
      "Accredited Senior Agent ASA"
    ]
  },
  {
    id: 102,
    name: 'Peter Mickus',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'petermickus@johnstonanddaniel.com',
    // phone: '416.920.5888',
    image: agent_102Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      "With a deeply rooted history in the Toronto, Oakville, Caledon and surrounding areas, Peter provides expert and comprehensive guidance to the unique needs of each client. Priding himself on providing dedicated one-on-one service to all his clients, you can buy or sell your next home with confidence knowing that when you choose Peter, you work with Peter. Peter has a deep association with the equestrian world and has represented clients that have owned world class equestrian farms and magnificent rural estates in rural Burlington and Halton. With his many world wide connections, Peter is the go to agent for these high value rural properties. Being a former commercial airline pilot, Peter has extensive experience and training that has defined his character and has provided him with the most sought after traits in real estate: impeccable attention to detail, integrity, and trust. With his vast knowledge of the real estate market and a knack for understanding people, he works tirelessly to meet and exceed his client’s expectations. With a deep-seated passion for real estate and an appreciation for family, Peter brings a wealth of personal experience to serve clients in Toronto, Oakville, Caledon, Burlington, and surrounding areas."
    ]
  },
  {
    id: 103,
    name: 'Carol Mintz',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'mail@carolmintz.com',
    phone: '416.879.5631',
    image: agent_103Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about: [
      `Energy, Enthusiasm, Efficiency & Success. "I have found Carol Mintz to be extremely professional, hardworking, most helpful, and more importantly, very nice. Need I say more?" J. Cowan Carol Mintz is a highly respected and successful Real Estate Sales Professional who has established herself in the Toronto Luxury Home and Condominium Markets Setting benchmark prices, dealing with complex transactions, and providing unparalleled client service are all her trademarks. Carol thrives on hard work, challenges, and above all, succeeds with persistent determination. "It is important to give your utmost," Carol says. And she means it too. As a recognized medical professional and a designer, she soared in both fields. Utilizing her skills in the real estate profession, Carol, after over two and a half decades, is known as much by her valued client references as her dynamic personality — and of course her outstanding sales! Add to that the human factor and her great love of animals; it is easy to understand why Carol is a Winner.`,
      ` "I pride myself on my people skills," she notes. "Optimism and a positive attitude are extremely important, alongside thorough professionalism and exceptional product knowledge. Attention to detail is critical." Does success run in the family? Yes! Carol’s two children both have their Master Degrees from Prestigious Universities. They both successfully run their own Business — each in their specialized careers. FOR SELLERS Reasons why Carol Mintz should sell your home: • Highly recommended with Proven Track Record • Consistent Award Winner • Dedicated Service with Personalized ‘Hands On’ Approach • Specialized with Extensive Market Knowledge • Extremely Motivated; with Expert Negotiating Skills • Representing the #1 Company in Canada for value of Residential Listings Sold - repeatedly • Representing Canada’s largest Corporate Relocation Company • Will Maximize your Selling Price • To introduce as many qualified buyers as possible to your home until "SOLD" • To constantly communicate the results of our activities to you • To utilize the best methods and means to effectively expose your property in order to achieve "SOLD" for the absolute maximum FOR BUYERS Reasons why Carol Mintz should assist you with the purchase of your new home: • Personal 'Hands On' Approach • Highly recommended with Proven Track Record • Extensive Market Knowledge - Specialized • Extremely Motivated - Driven • Dedicated Service - undoubtedly will go the extra mile • Someone who constantly has her 'Ear to the Ground' and "Will Leave No Stone Unturned"`
    ]
  },
  {
    id: 104,
    name: 'David Naghdi',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'davidnaghdi@gmail.com',
    phone: '416.721.4342',
    image: agent_104Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 105,
    name: 'Roger Nahas',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'roger@rogernahas.com',
    phone: '416.489.2121',
    image: agent_105Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/therogernahas',
    in: 'https://www.instagram.com/rogernahas',
    li: 'https://www.linkedin.com/in/therogernahas/',
    yt: 'https://www.youtube.com/@TheRogerNahas',
    about: [
      "As a real estate agent and an investor, I’m passionate about helping you find or sell your home, as well as showing you how to build generational wealth and financial independence through real estate investing.",
      "What sets me apart from my counterparts is my mastery  in the art of negotiation and my commitment to understanding your needs and goals. Instead of focusing solely on transactions, I prioritize a personalized approach.  My dedication to data-driven decision-making is a cornerstone of my practice.  By analyzing market trends and utilizing comprehensive data, I will equip you with the knowledge needed to make informed choices,  provide you with an Upgraded Experience and ultimately build a long lasting relationship.",
      "Prior to launching my career in real estate, I studied Economics and Marketing at the University of Ottawa.  In 2007,  I co-founded a fitness and health company in Toronto.I grew the business and spearheaded its Global Expansion into other parts of Canada, Switzerland and France.  In 2010 I had the honour of being recognized as one of Canada’s Top 50 Fastest Growing Companies.",
      "Ultimately, I have been able to transfer my business acumen, marketing savvy and overall knowledge of economics to the real estate market. ",
      "I am  also deeply committed to giving back to the community with both my time and money.  Since 2016, I have been a volunteer hockey coach for the North Toronto Hockey Association and a supporter of numerous charitable organizations. Those particularly close to my heart include Bopoma Villages, Access Alliance Holiday Hamper Program, and the Royal Lepage Shelter Foundation  and I donate a percentage of every dollar I earn to these charities."
    ]
  },
  {
    id: 106,
    name: 'Victor Ness',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'boris@agentboris.com',
    phone: '416.920.5888',
    image: agent_106Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb: 'https://www.facebook.com/victor.ness.52',
    in: 'https://www.instagram.com/victornessrealty',
    li: 'https://www.linkedin.com/in/victorness',
    about: [
      "Victor has over 30 years of sales and marketing experience. He has found a personal satisfaction in helping people. With experience in negotiating, budgeting, profitability, investor relations, marketing concepts, and implementation of national accounts with senior executives and CEO’s.",
      "His career in Real Estate with Johnston & Daniel a division of Royal LePage, was chosen for what they stand for, integrity, class, sophisticated back office and exceptional people and their powerful brand awareness.",
      "He has shown leadership and expertise in software manufacturing, software, healthcare, sales and marketing, start-ups, project management, business development. I have been able to create an immediate connection with clients. I have the sensitivity to foster long-term relationships, with keen listening skills and be part of the change environment in your home buying or listing decisions with strong negotiating skills.",
      "OUR GOAL is to help you make great decisions, I understand that to do this you need an educator, strong negotiator, informer, emotional support, someone with knowledge and experience and a calm demeanor. This will lead to confidence. Confidence in the process and ultimately in me helping you make one of the biggest decisions of your life.",
      "Committee’s: TRREB Committee Member 2020-2021 – MLS Technology and related services",
      "Awards: President’s Award Recipient"
    ]
  },
  {
    id: 107,
    name: 'Joanne	Nevison',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jnevison@sympatico.ca',
    phone: '416.605.4003',
    image: agent_107Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 108,
    name: 'Sam Obeid',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sam@samobeid.com',
    phone: '416.737.0057',
    image: agent_108Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 109,
    name: 'Laura Catherine Oldman',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'results@lauraoldman.com',
    phone: '416.435.2641',
    image: agent_109Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Laura Oldman graduated from the University of Western Ontario with a Bachelor of Science, Honours Specialization in Kinesiology. She completed her Bachelor of Education at Queens University and has since established an excellent reputation in the teaching profession. Laura has many years of interior design experience with home and cottage renovations all over Ontario. She is an excellent communicator and is dedicated to finding the perfect home for her clients. Her attention to detail, knowledge of houses in the Toronto area and love for design gives her a unique set of skills that contribute to her love for real estate. Laura has an exceptional work ethic and is a positive and reliable agent to help you to find your dream home."
    ]
  },
  {
    id: 110,
    name: 'Michael Owen',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'michael@myrealestatepro.ca',
    phone: '416.996.6936',
    image: agent_110Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 111,
    name: 'Arthur Parks',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'arthur@arthurparks.com',
    phone: '416.489.2121',
    image: agent_111Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Arthur started his real estate career in March 1987.",
      "He has never looked back.",
      "His successful real estate career started immediately and he has enjoyed being in the top 1% of real estate agents in Toronto for many years.",
      "Arthur Parks, an alumni of Ryerson University, majored in finance from the esteemed institution.",
      "His professional journey commenced at the Bank of Nova Scotia in 1971, where he rapidly ascended the corporate ladder, holding pivotal management roles both at the branch and head office levels.",
      "Following his tenure at the bank, Arthur undertook the mantle of General Manager at two prominent Toronto-based companies, showcasing his exceptional leadership acumen.",
      "His innate love for the art of buying and selling his personal real estate beckoned him to transition his formidable management and personnel skills into a thriving real estate career.",
      "Throughout his career, his genuine interest in people, his desire to assist and serve people and to receive their appreciation, his love of architecture and an extremely strong work ethic coursed through Arthur’s veins.",
      "Why He Loves Real Estate",
      "Arthur’s ardor for real estate is underpinned by his entrepreneurial spirit.",
      "In the realm of real estate, every agent operates as a distinct business entity under the aegis of a brokerage firm.",
      "It’s a synergy Arthur deeply cherishes, and he has found his ideal partner in Royal LePage/Johnston & Daniel Division, a brokerage firm renowned for its rich heritage and sterling reputation.",
      "Arthur remains an indefatigable workaholic, eagerly embracing each day and its attendant challenges.",
      "He thrives on the appreciation showered upon him, eloquently documented in the “Endorsement” section of his website, arthurparks.com",
      "Innovation is the lifeblood of Arthur’s approach to real estate.",
      "Continually brewing new ideas for property promotion, he relishes sharing his insights with fellow realtors, dedicated to elevating the standards of professionalism within the industry."
    ],
    career:[
      //His Career Today
      "Though Arthur officially embarked on the path of semi-retirement eight years ago, he shows no signs of slowing down.",
      "He established himself again in the idyllic Lakefield, nestled within the Peterborough & The Kawarthas region, conveniently close to his cherished cottage.",
      "His boundless energy is channeled into serving both the bustling Toronto market and the serene Peterborough & The Kawarthas market"
    ],
    awards:[
      //Awards & Recognition
      "Beyond his professional pursuits, Arthur has been a devoted Rotarian for many years and has recently being elected as the incoming President of the Rotary Club of Toronto Eglinton which meets in the Yonge/Summerhill area of Toronto.",
      "This further underscores his commitment to community involvement.",
      "Throughout his storied real estate career, Arthur has amassed a treasure trove of accolades, including numerous prestigious awards for his outstanding sales volume.",
      "Yet, his most cherished reward remains the profound respect he garners from his fellow agents and the heartfelt appreciation of his many loyal clients."
    ]
  },
  {
    id: 112,
    name: 'Mary C.	Parks',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'mparks@johnstonanddaniel.com',
    // phone: '416.920.5888',
    image: agent_112Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Mary and Arthur just celebrated 50 years of marriage.",
      "Mary has also been a real estate agent for over three decades.",
      "Mary's education, a graduate from Humber College, and her prior business experience as a legal secretary for many years with a very progressive Toronto Law Firm, Lyons Arbus, have contributed to her very organized business approach. ",
      "Mary's family has been cottaging in the Kawarthas since the 30's. "

    ]
  },
  {
    id: 113,
    name: 'Phillippa Perkins',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'pperkins@johnstonanddaniel.com',
    phone: '416.454.1460',
    image: agent_113Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 114,
    name: 'Peter Ricketts',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'peterricketts@hotmail.com',
    phone: '647.631.8327',
    image: agent_114Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 115,
    name: 'Lina Risi',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'lina@postcardhomes.com',
    phone: '416.508.5462',
    image: agent_115Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 116,
    name: 'Ingrid Ruytenbeek',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ingrid@royallepage.ca',
    phone: '416.997.6317',
    image: agent_116Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 117,
    name: 'Terri Sapera',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'terrisapera@gmail.com',
    phone: '416.618.7449',
    image: agent_117Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    in: 'https://www.instagram.com/Terri%20Sapera',
    li: 'https://www.linkedin.com/in/Terri%20Sapera',
    about:[
      "A Gardiner, Diamond and Award of Excellence recipient, Terri Sapera joined Royal LePage Real Estate Services Ltd., Johnston and Daniel Division in 2006. Terri continues a family legacy passed on to her by her late mother Ethel Sapera. Ethel worked for Johnston & Daniel for nearly forty years and was considered a pioneer in the industry. Applying what she learned from her mother during their partnership, Terri brings over 35 years experience in sales. Terri specializes in residential properties and condominiums in the central core of the city: particularly Yorkville, Forest Hill, Rosedale and Bayview & York Mills. Residing in Yorkville, Terri is extremely knowledgeable in the condo market and has sold many condos in the city, ranging from one bedroom pied-a-terre suites to the finest penthouses. Growing up in Toronto has given Terri a vast knowledge of the different neighbourhoods that comprise this wonderful city. After graduating with a Bachelor of Arts from York University Terri went on to obtain a degree in Fashion, Buying and Merchandising at The Fashion Institute of Technology in New York City. After pursuing a career in fashion, Terri went on to work in the promotional products industry. With her promotions and marketing background, she is able to devise unique and creative approaches to selling properties. Royal LePage R.E.S. Ltd., Johnston & Daniel Division offers an affiliation with international listing partners PropGoLuxury, ListGlobally, Juwai, Who's Who in Luxury Real Estate & LuxuryHomes. Luxury properties are advertised across 120+ of the most power luxury real estate platforms, appearing in over 60 countries and translated into 16 languages. When Terri is not selling homes her hobbies include pilates, playing the piano, hiking, downhill skiing and travelling. Terri's solid reputation, integrity and hard work have resulted in many successful transactions and satisfied clients."
    ]
  },
  {
    id: 118,
    name: 'Farhang Sattar',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'farhangsattar@johnstonanddaniel.com',
    // phone: '416.920.5888',
    image: agent_118Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 119,
    name: 'Jonathan Schwarz',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'jon@revgroup.ca',
    // phone: '416.920.5888',
    image: agent_119Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Jonathan Schwarz: Elevating Luxury Real Estate",
      "Jonathan Schwarz, a distinguished Broker with Johnston & Daniel, brings nearly two decades of unparalleled expertise in real estate sales and marketing, focusing on luxury homes and condominiums in Toronto's most prestigious neighborhoods. His career, exclusively dedicated to real estate, is marked by a relentless commitment to excellence and a passion for providing bespoke services to his clients.",
      "In August 2013, Jonathan founded Revolution Realty, setting a new standard for client service in the industry. After nearly 11 years of success, he merged Revolution Realty with Royal LePage Real Estate Services Ltd., Johnston & Daniel Division, to further enhance his offerings. This merger birthed Revolution Group, a team of meticulously selected Realtors who share Jonathan's values, ethics, and dedication to outstanding customer service.",
      `Jonathan's approach is deeply personal and client-centric. Whether facilitating the purchase of a $15 million home in the Bridal Path or guiding first-time renters, Jonathan’s vast experience across various real estate facets—including pre-construction condominium sales, residential land sales, and commercial transactions—ensures that every client receives exceptional service tailored to their unique needs. His grandfather's wisdom, "a person's word is their bond," underscores his professional ethos.`,
      "Jonathan's work with TRREB underscores his commitment to advancing the real estate profession and enhancing industry standards. His dedication to luxury real estate, combined with his extensive knowledge and unwavering integrity, makes him an ideal partner for discerning clients seeking exceptional real estate services in Toronto."
    ],
    career:[
      //His Career Today
      "Jonathan holds numerous professional designations, reflecting his specialized skills and dedication to excellence:",
      "Accredited Elite Advocate (AEA)",
      "Accredited Buyer Representative (ABR®)",
      "Certified Luxury Home Marketing Specialist (CLHMS®) with Million Dollar Guild",
      "Certified Negotiation Expert (CNE®)",
      "Seller Representative Specialist (SRS®)"
    ],
    more:[
      "Beyond his professional accomplishments, Jonathan is a dedicated volunteer and active member of the Toronto Regional Real Estate Board (TRREB). His significant contributions include serving on multiple key committees:",
      "MLS Technology & Related Services Committee (2020-2023)",
      "Arbitration Roster (2015-2020)",
      "Condo Committee (2016-2017)",
      "Nominating Committee (2023)"
    ]

  },
  {
    id: 120,
    name: 'Eleonora Segal',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'eleonorasegal@gmail.com',
    phone: '416.458.9595',
    image: agent_120Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb:'https://www.facebook.com/eleonora.segal',
    x:'https://twitter.com/elisegal',
    in:'https://www.instagram.com/ELEONORASEGAL',
    li:'https://www.linkedin.com/in/eleonorasegal',
    about:[
      "Eleonora launched her real estate career in 1990 and has consistently won numerous prestigious real estate awards of recognition for outstanding performance within Royal LePage/Johnston and Daniel Division, the most successful real estate office in Canada. Eleonora's hard work and dedication gained its due recognition when she achieved the Diamond Award of Merit, the Gairdner Award and the Award of Excellence. Eleonora is dedicated and professional, spending countless hours following up leads, doing open houses and showing properties including nights and weekends. Her expertise and track record demonstrate prioritizing her client's interest above her own. Eleonora is a proven outstanding negotiator. She specializes in fine homes and luxury condominiums in prestigious neighborhoods such as Forest Hill, Yorkville, Avenue Road and Lawrence, downtown Toronto and the Waterfront. Eleonora ( or Ellie as many of her friends and clients call her) is passionate , persistent and dedicated, usually exceeding her client's expectations by delivering her expert knowledge of the market conditions. She combines innovative and unique marketing strategies with leading edge technology to get properties sold to the full satisfaction of both sellers and buyers. Eleonora is fluent in English, Spanish and Hebrew and has a good command of French. She has an Honors Bachelor Degree from Tel Aviv University."
    ]
  },
  {
    id: 121,
    name: 'Susie Sheffman',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ssheffman@gmail.com',
    phone: '416.315.6737',
    image: agent_121Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 122,
    name: 'Ashlee Shutt',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ashlee.shutt@gmail.com',
    phone: '416.312.4068',
    image: agent_122Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 123,
    name: 'Rosalin Smith-Carr',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'rsmithcarr@icloud.com',
    phone: '416.409.6896',
    image: agent_123Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Biochemistry Degree from University College, Dublin, Ireland. Worked in medical research at The Best Institute and Hospital for Sick Children; Pharmaceutical Sales Representative for Bayer. Real Estate ironically captured my heart when I made a very wrong first home purchase. No such thing as behaviour without a reason!"
    ]
  },
  {
    id: 124,
    name: 'Selena Soscia',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ssoscia@johnstonanddaniel.com',
    phone: '647.526.5699',
    image: agent_124Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 125,
    name: 'Mark Spraggett',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'mark@sellmyproperty.com',
    phone: '416.809.9281',
    image: agent_125Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 126,
    name: 'Randy Stevenson',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'randystevenson@rogers.com',
    phone: '647.921.6882',
    image: agent_126Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 127,
    name: 'Alison Strike',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'alisonstrike@rogers.com',
    phone: '647.223.2903',
    image: agent_127Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 128,
    name: 'Shery & Christina Sutherland',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ssutherland@johnstonanddaniel.com',
    phone: '905.330.4046',
    image: agent_128Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 129,
    name: 'Sherry Sutherland',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'ssutherland@johnstonanddaniel.com',
    phone: '905.330.4046',
    image: agent_129Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Sherry received her undergraduate degree from the University of Alberta prior to becoming an interior designer in 2003. Sherry has personally moved thirteen times, built five homes and renovated twelve properties over the last twenty-five years. Her vast skillset prepared her for a career in Real Estate. Sherry is committed to helping her clients find their ideal home. She currently resides in South East Oakville where she has lived for over 30 years."
    ]
  },
  {
    id: 130,
    name: 'Christina Sutherland',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'csutherland@johnstonanddaniel.com',
    phone: '905.467.3756',
    image: agent_130Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    about:[
      "Christina has worked in non-profit, finance and received her M.B.A., from the Rotman School of Management prior to co-founding My Stewards Inc., and becoming a licensed agent. She has lived most of her life in Oakville and has vast knowledge of the communities and school districts. She currently resides in Oakville with her husband and two sons. "
    ]
  },
  {
    id: 131,
    name: 'Sarah Syrja',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sarah@syrjateam.com',
    phone: '416.489.2121',
    image: agent_131Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 132,
    name: 'Robin Tully',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'tullyrobin@gmail.com',
    phone: '416.885.5743',
    image: agent_132Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 133,
    name: 'Erik	Vail',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'e.vail@sympatico.ca',
    phone: '416.845.9599',
    image: agent_133Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 134,
    name: 'Kim	Valberg',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'kim@kimvalberg.com',
    phone: '416.565.1021',
    image: agent_134Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 135,
    name: 'Geon Van Der Wyst',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'geon@propertiesinstyle.com',
    phone: '416.824.3527',
    image: agent_135Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 136,
    name: 'Trish Vieira',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'trishvieira2@gmail.com',
    phone: '416.489.2121',
    image: agent_136Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
    fb:'https://www.facebook.com/trishvieirarealestate/',
    in:'https://www.instagram.com/trish_vieira/?hl=en',
    about:[
      "With over 20 years combined as an Operations Manager for two of the most successful food and retail companies, I knows business!  From being a mentor, turning chaos into calm and getting things done, she has worked with, managed over 80 employees at one time, and has had success managing businesses that exceed client’s expectations.",
      "Many years ago, I finally decided to exercise the trade that would combine for me work and pleasure.",
      "Real estate is more than just a job, it’s a passion that fills me with amazing encounters and allows me to create a strong relationship of trust with my clients.",
      "Every real estate project is unique, simple and complex at the same time. I know how much discretion, confidence, seriousness, listening, efficiency and tenacity are essential qualities for success in this profession."
    ]
  },
  {
    id: 137,
    name: 'Leslie Wallender-Lyons',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'leslie@leslielyons.ca',
    phone: '416.523.6000',
    image: agent_137Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 138,
    name: 'Sherri Watchorn',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sherriwatchorn@rogers.com',
    phone: '416.358.3768',
    image: agent_138Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 139,
    name: 'Sis Weld',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'sweld@sympatico.ca',
    phone: '416.818.3446',
    image: agent_139Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 140,
    name: 'Leeanne Weld',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'leeanne@leeanneweld.com',
    phone: '416.566.8603',
    image: agent_140Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 141,
    name: 'Caroline Wight',
    role: 'Broker',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'caroline@carolinewight.com',
    phone: '416.587.4386',
    image: agent_141Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 142,
    name: 'Gayle Woods',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'gaylewoods@johnstonanddaniel.com',
    phone: '416.275.8009',
    image: agent_142Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 143,
    name: 'Julia Zipresz',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'juliaurquhart@sympatico.ca',
    phone: '416.994.0974',
    image: agent_143Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  },
  {
    id: 144,
    name: 'Farahnaz Zolfaghari',
    role: 'Sales Representative',
    location: 'Johnston & Daniel Division, Royal LePage Real Estate Services Ltd., Brokerage',
    email: 'juliaurquhart@sympatico.ca',
    phone: '416.994.0974',
    image: agent_144Img,
    language: 'English',
    position: 'Agent',
    designation: 'ABR - Accredited Buyers Representative',
    profileLink: '/profile/john-doe',
    office: 'J&D Toronto',
  }
];